import * as Sentry from '@sentry/nextjs'

import { registerClientTelemetry } from '@thebeansgroup/js-open-telemetry/otel/client'

import FeatureToggle from '@helpers/feature_toggle'

registerClientTelemetry(
  FeatureToggle.isEnabled('client_side_traces'),
  FeatureToggle.isEnabled('client_side_metrics'),
  process.env.NEXT_PUBLIC_OTEL_NAME,
  process.env.NEXT_PUBLIC_APP_ENV,
  process.env.NEXT_PUBLIC_OTEL_CLIENT_TRACES_ENDPOINT,
  process.env.NEXT_PUBLIC_OTEL_CLIENT_METRICS_ENDPOINT,
  process.env.NEXT_PUBLIC_OTEL_CLIENT_API_KEY,
  process.env.NEXT_PUBLIC_OTEL_CLIENT_SAMPLING_RATE,
  process.env.NEXT_PUBLIC_OTEL_METRIC_SAMPLING_RATE
)

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN

const APP_ENV = process.env.APP_ENV || process.env.NEXT_PUBLIC_APP_ENV

if (['staging', 'production'].includes(APP_ENV)) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: APP_ENV,
    allowUrls: [
      /https?:\/\/(www\.)?((marketplace\.staging|test)\.)?(beansid)\.com/,
      /https?:\/\/cdn\.(staging\.)?studentbeans\.com/
    ]
  })
}
